@if(!hideHeader){
<div class="title-container">
  <div class="title-container__title">
    <h4>{{ 'NGX-MESSAGING.allUsers' | translate }}</h4>
    @if (canUseFilter) {
    <mat-icon class="filter" [matMenuTriggerFor]="menuFilters" svgIcon="filters"></mat-icon>
    }
    <mat-menu #menuFilters>
      <button mat-menu-item (click)="toggleShowFilterInput()">
        {{
          !showFilterInputSignal()
            ? ('NGX-MESSAGING.USERS.showSearchInput' | translate)
            : ('NGX-MESSAGING.USERS.hideSearchInput' | translate)
        }}
      </button>
      <button mat-menu-item (click)="toggleShowFilterTags()">
        {{
          !showFilterTagsSignal()
            ? ('NGX-MESSAGING.USERS.showTeamsFilter' | translate)
            : ('NGX-MESSAGING.USERS.hideTeamsFilter' | translate)
        }}
      </button>
    </mat-menu>
  </div>
  @if(showSelectAll){
  <div class="title-container__check">
    <mat-checkbox [disabled]="isLoadingUsersSignal()" (change)="selectAll($event)"></mat-checkbox>
  </div>
  }
</div>
} @if (showFilterTagsSignal()) {
<ngx-tags (tagsChangedEvent)="tagsChanged($event)" [showTitle]="false" [tagsSelected]="tagsFilterSignal()"></ngx-tags>
} @if (showFilterInputSignal()) {
<mat-form-field appearance="fill" class="search-input">
  <input matInput placeholder="{{ 'NGX-MESSAGING.USERS.typeToFilterUsersByName' | translate }}" #usersSearch />
</mat-form-field>
}

<div
  class="member-list list-all"
  [ngStyle]="{ height: maxUsersListHeigt }"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="20"
  (scrolled)="nextPage()"
  [scrollWindow]="false">
  @if (!isLoadingAllCheckSignal()) { @for (member of usersSignal(); track member.uid) {
  <div class="member-list__items" (click)="selectMemberDirect(member)">
    <messaging-avatar
      [src]="$safeNavigationMigration(member?.profileImageURL)"
      [name]="$safeNavigationMigration(member?.displayName)"
      [initialsSize]="2"
      size="40">
    </messaging-avatar>
    <div class="member-list__text">
      <p>{{ member.displayName }} @if(member.disabled) { (added)}</p>
      @if(!hideCheckbox){

      <mat-checkbox
        [disabled]="member.disabled"
        (change)="selectMember(member)"
        [checked]="isUserSelected(member)"></mat-checkbox>
      }
    </div>
  </div>
  } } @if (isLoadingUsersSignal()) {
  <div class="loading">
    <div>
      {{ 'NGX-MESSAGING.loadingUsers' | translate }}
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
  </div>
  } @if (!isLoadingUsersSignal() && !usersSignal().length) {
  <div class="loading">
    <div>No users found</div>
  </div>
  }
</div>
